import BlockedIcon from '@/assets/icons/BlockedIcon';
import IconifyIcon from '@/components/IconifyIcon/IconifyIcon';
import { MAGNET_TYPE } from '@/constants/bot';
import clsx from 'clsx';
import * as React from 'react';

interface IMagnetActionTypeProps {
  fileType?: MAGNET_TYPE;
}

const MagnetActionType: React.FunctionComponent<IMagnetActionTypeProps> = ({ fileType }) => {
  const label = {
    [MAGNET_TYPE.VIDEO]: 'Video',
    [MAGNET_TYPE.IMAGE]: 'Image',
    [MAGNET_TYPE.PDF]: 'PDF',
  };

  const icon = {
    [MAGNET_TYPE.VIDEO]: 'tabler:video-filled',
    [MAGNET_TYPE.IMAGE]: 'tabler:photo-filled',
    [MAGNET_TYPE.PDF]: 'tabler:file-filled',
  };

  return (
    <div className='flex items-center gap-1'>
      <div className='w-8 h-8 flex justify-center items-center bg-gray-100 rounded-full'>
        {fileType ? (
          <IconifyIcon name={icon[fileType as keyof typeof icon]} size={16} color='#3A72FE' />
        ) : (
          <BlockedIcon />
        )}
      </div>
      <p className={clsx('text-s font-medium', !!fileType ? 'text-black' : 'text-gray-500')}>
        {fileType ? label[fileType as keyof typeof label] : 'NA'}
      </p>
    </div>
  );
};

export default MagnetActionType;
